export function client(data) {
    const { custom } = data;

    const {
        medical_book,
        salary,
        salary_required,
        work_schedule,
        work_schedule_own_variants,
        work_schedule_save_own_variants,
        work_start,
        work_start_required,
    } = custom || {};

    return {
        career: {
            medicalBook: !!medical_book,
            salaryShow: !!salary,
            salaryRequired: !!salary ? !!salary_required : false,
            schedule: {
                show: !!work_schedule,
                custom: !!work_schedule_own_variants,
                saveCustom: !!work_schedule_save_own_variants,
                variants: [],
            },
            workStartShow: !!work_start,
            workStartRequired: !!work_start ? !!work_start_required : false,
        },
    };
}

export function server(data) {
    const { career } = data;

    const { medicalBook, salaryShow, salaryRequired, schedule, workStartShow, workStartRequired } = career;
    const { show, custom, saveCustom } = schedule;

    return {
        custom: {
            medical_book: medicalBook,
            salary: salaryShow,
            salary_required: salaryRequired,
            work_schedule: show,
            work_schedule_own_variants: custom,
            work_schedule_save_own_variants: saveCustom,
            work_start: workStartShow,
            work_start_required: workStartRequired,
        },
    };
}
